import React, { useState } from 'react';
import { Tab, Tabs, Card, CardContent, Checkbox, Grid } from '@mui/material';
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Container,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Button,
  Paper
} from '@mui/material';
import { motion } from 'framer-motion';
import { keyframes, textAlign } from '@mui/system';
import { db} from "./../../firebase";
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { getDocs } from "firebase/firestore"; 
const fadeInSlideUp = keyframes`
from {
  opacity: 0;
  transform: translateY(20px);
}
to {
  opacity: 1;
  transform: translateY(0);
}
`;
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}
function JanAushadhiForm() {
  const [value, setValue] = React.useState(0);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [unlockedSteps, setUnlockedSteps] = useState([true, false, false]); // Step access control
   const unlockNextStep = () => {
    setUnlockedSteps((prev) => {
      const updated = [...prev];
      updated[value + 1] = true; // Unlock the next step
      return updated;
    });
    setValue(value + 1); // Move to the next step
  };  
  const [formData, setFormData] = useState({
    applicantName: '',
    applicantStatus: '',
    phoneNumberMobile: '',
    phoneNumberLandline: '',
    applicantEmail: '',
    postalAddress: '',
    pincode: '',
    aadhaarNumber: '',
    panNumber: '',
    educationalQualification: '',
    managerName: '',
    degree: '',
    registrationNumber: '',
    storeLocation: '',
    tehsil: '',
    city: '',
    district: '',
    pincode: '',
    state: '',
    locationOwnership: 'Owned',
    locationJustification: '',
    nycsShareNumber: '',
    shareHoldingAmount: ''
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log('Form submitted:', formData);
    try {
          console.log("form data ",formData);
          // fetchData();  
          // console.log('Attempting to submit:', testData);
          await addDoc(collection(db, "JanAushashiForm"), formData);
    
          // console.log("Document written with ID: ", docRef.id);
          alert("Form submitted successfully!");
          
          // Clear form fields
          
        } catch (error) {
          console.error("Error adding document: ", error);
          console.error("Error message:", error.message);
          alert("Error submitting form!");
        }
        setFormData({
          applicantName: '',
          applicantStatus: '',
          phoneNumberMobile: '',
          phoneNumberLandline: '',
          applicantEmail: '',
          postalAddress: '',
          pincode: '',
          aadhaarNumber: '',
          panNumber: '',
          educationalQualification: '',
          managerName: '',
          degree: '',
          registrationNumber: '',
          storeLocation: '',
          tehsil: '',
          city: '',
          district: '',
          pincode: '',
          state: '',
          locationOwnership: 'Owned',
          locationJustification: '',
          nycsShareNumber: '',
          shareHoldingAmount: ''
        })
        setTermsAccepted(false)
        setUnlockedSteps([true,false,false])
        setValue(0)
  };
  const handleChangetab = (event, newValue) => {
    if (unlockedSteps[newValue]) {
      setValue(newValue);
    }
  };

  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };
  const handleButtonClick = () => {
    // setValue((prev) => prev + 1); // Switch to the second tab panel
    unlockNextStep()
  };

  const handleCheckboxChange = (event) => {
    setTermsAccepted(event.target.checked);
  };
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      {/* Title of Page */}
      <Typography
        variant="h2"
        sx={{
          textAlign: "center",
          mb: 10,
          color: "#006a62",
          fontWeight: "bold",
          animation: `${fadeInSlideUp} 1.2s ease-out`,
          textShadow: "2px 2px 4px rgba(0,0,0,0.1)"
        }}
      >
        Jan Aushadhi Form
      </Typography>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChangetab}
            centered
            variant="fullWidth"
          >
           
           <Tab label="Step 1" disabled={!unlockedSteps[0]} />
          <Tab label="Step 2" disabled={!unlockedSteps[1]} />
          <Tab label="Step 3" disabled={!unlockedSteps[2]} />


          </Tabs>
        </Box>

        <TabPanel value={value} index={0}>
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <Card>
                  <CardContent>
                    <Typography
                      variant="h4"
                      sx={{
                        textAlign: "center",
                        mb: 4,
                        color: "#006a62",
                        fontWeight: "bold",
                        animation: `${fadeInSlideUp} 1.2s ease-out`,
                        textShadow: "2px 2px 4px rgba(0,0,0,0.1)"
                      }}
                    >
                      About Jan Aushadhi Yujna

                    </Typography>

                    <Typography
                      variant="body1"
                      gutterBottom
                      sx={{
                        textAlign: "justify",
                        mt: 2,
                        fontSize: { xs: "1rem", md: "1.1rem" },
                        lineHeight: 1.8,
                      }}
                    >
                      National Yuva Cooperative Society(NYCS) believes and works towards making potential growth for a sustainable life a definite possibility amongst people of India particularly the youth. Sustainable growth of an individual is a product of his physical and mental strength coupled with his efforts. Thus, good health is a prime factor in overall development of youth and nation.

                      In line with Prime Minister Shri. Narendra Modi’s vision of “Swastha Bharat” Department of Pharmaceuticals has launched the PMBJP scheme to take their initiative to make quality medicines and affordable medicines a reality in India. NYCS has partnered with Bureau of Pharma PSUs of India (BPPI), a division of the department, for implementing the PMBJP scheme and establishing multiple Jan Aushadhi Centres all across the nation to make effective and affordable generic medicine easily accessible to the people.<br />

                      It is a two way benefit scheme where the customer and the pharmacist both are benefitted. NYCS has signed an MOU with BPPI and is entrusted with the responsibility of opening 1000 Jan Aushadhi Kendras till March 2017. We have begun our mission and invite public to join us and strengthen our efforts. We are looking for genuine public partners to participate in the scheme.
                      <br />
                      While every customer will benefit from the scheme in regards of quality and affordability, there are clear and motivating incentives, discounts and profit margins for the pharmacists too. If you are reading this and find this interesting contact us for the further details, formalities, rules and procedure for opening a Pradhan Mandtri Janaushadhi Kendra with NYCS. Fill in the following form and submit it to us. You will hear from us at the earliest.
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center", // Centers horizontally
                        alignItems: "center", // Centers vertically
                        height: "100%", // Optional, ensures it centers within a larger container
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          fontSize: "20px",
                          bgcolor: "#003733",
                          textAlign: "center",
                          "&:hover": {
                            bgcolor: "#004d48",
                          },
                        }}
                        onClick={handleButtonClick}
                      >
                        Apply for PMBJP Yojna
                      </Button>
                    </Box>

                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </motion.div>
        </TabPanel>

        {/* Second TabPanel */}
        <TabPanel value={value} index={1}>
          <motion.div {...fadeIn}>
            <Typography
              variant="h4"
              sx={{
                textAlign: "center",
                mb: 4,
                color: "#006a62",
                fontWeight: "bold",
                animation: `${fadeInSlideUp} 1.2s ease-out`,
                textShadow: "2px 2px 4px rgba(0,0,0,0.1)"
              }}
            >
              Terms & Conditions

            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>At the time of application:</strong>
            </Typography>
            <ol>
              <li>
                A business space of 120 sq. ft. or more (Owned or rented) duly supported by ownership documents or lease agreement/space allotment letter (For minimum 36 months).
              </li>
              <li>
                Proof of securing a pharmacist with name and registration with the state pharmacy council is mandatory at the time of application.
              </li>
              <li>Investment capacity of a minimum ₹3 Lakh (approx).</li>
            </ol>
            <Typography variant="body1" gutterBottom>
              <strong>If the application is approved:</strong>
            </Typography>
            <ol>
              <li>
                The applicant will need to enter an agreement with NYCS before commencing the operations of the approved Pradhan Mantri Bharatiya Janaushadhi Kendra (PMBJK). All operations of the PMBJK will be conducted as per agreement terms and conditions.
              </li>
              <li>
                The applicant will need to obtain the required drug license in the name of PMBJK and other permissions to run the store. Compliance to all statutory requirements for the storage of drugs shall be ensured by the applicant.
              </li>
              <li>
                Applicant will use the premises solely for the purpose for which it has been allotted and for no other purpose and shall not part with the premises, sub-let the premises to anyone directly or indirectly.
              </li>
              <li>
                All billings should be done using the software provided by BPPI & NYCS. No medicine can be sold in PMBJK without using the software provided by BPPI & NYCS.
              </li>
              <li>
                PMBJK operators will be allowed to sell allied medical products commonly sold in chemist shops with prior written permission of NYCS only. However, no medicine other than those included in the PMBJP will be allowed to be sold through these kendras.
              </li>
              <li>
                The BPPI/NYCS distributor will take back expired medicines/breakage to the maximum extent of 2% of the total purchase value by the PMBJK.
              </li>
              <li>
                Credit period of 30 days will be given from the date of receipt of medicines by PMBJK. A post-dated cheque will be required to be given by the PMBJK in advance against goods supplied.
              </li>
              <li>
                If approved, you will have to become a member of NYCS Ltd by paying the share capital of ₹5000 for 50 shares & ₹10 as share application money.
              </li>
              <li>
                A processing fee of ₹5000 will have to be paid to NYCS, if the PMBJK is approved for you.
              </li>
            </ol>
            <FormControlLabel
              control={<Checkbox checked={termsAccepted} onChange={handleCheckboxChange} />}
              label="I have read and understood the terms & conditions and agree to abide by them."
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center", // Centers horizontally
                alignItems: "center", // Centers vertically
                height: "100%", // Optional, ensures it centers within a larger container
              }}
            >
              <Button
                variant="contained"
                disabled={!termsAccepted}
                sx={{
                  fontSize: "20px",
                  bgcolor: "#003733",
                  textAlign: "center",
                  "&:hover": {
                    bgcolor: "#004d48",
                  },
                }}
                onClick={handleButtonClick}
              >
                Continue
              </Button>
            </Box>

          </motion.div>
        </TabPanel>

        {/* Third TabPanel */}
        <TabPanel value={value} index={2}>
          <Typography
            variant="h4"
            sx={{
              textAlign: "center",
              mb: 4,
              color: "#006a62",
              fontWeight: "bold",
              animation: `${fadeInSlideUp} 1.2s ease-out`,
              textShadow: "2px 2px 4px rgba(0,0,0,0.1)"
            }}
          >
            Application Form

          </Typography>
          {/* Add your form implementation here */}

          <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <TextField
              required
              fullWidth
              label="Name of the applicant"
              name="applicantName"
              value={formData.applicantName}
              onChange={handleChange}
            />

            <FormControl fullWidth required>
              <InputLabel>Status of the applicant</InputLabel>
              <Select
                name="applicantStatus"
                value={formData.applicantStatus}
                onChange={handleChange}
                label="Status of the applicant"
              >
                <MenuItem value="Individual Entrepreneur">Individual Entrepreneur</MenuItem>
                <MenuItem value="Charitable Institute/Hospital">Charitable Institute/Hospital</MenuItem>
                <MenuItem value="NGO/Trust">NGO/Trust</MenuItem>
                <MenuItem value="Government/Government Nominated Agency">Government/Government Nominated Agency</MenuItem>
                <MenuItem value="Any Other">Any Other</MenuItem>
                
                {/* Add appropriate status options */}
              </Select>
            </FormControl>

            <TextField
              required
              fullWidth
              label="Applicant Phone Number (Mobile)"
              name="phoneNumberMobile"
              value={formData.phoneNumberMobile}
              onChange={handleChange}
            />

            <TextField
              fullWidth
              label="Applicant Phone Number (Landline)"
              name="phoneNumberLandline"
              value={formData.phoneNumberLandline}
              onChange={handleChange}
            />

            <TextField
              required
              fullWidth
              label="Applicant Email"
              name="applicantEmail"
              type="email"
              value={formData.applicantEmail}
              onChange={handleChange}
            />

            <TextField
              required
              fullWidth
              label="Applicant Postal Address"
              name="postalAddress"
              multiline
              rows={3}
              value={formData.postalAddress}
              onChange={handleChange}
            />

            <TextField
              required
              fullWidth
              label="Pincode"
              name="pincode"
              value={formData.pincode}
              onChange={handleChange}
            />

            <TextField
              required
              fullWidth
              label="Aadhaar Number"
              name="aadhaarNumber"
              value={formData.aadhaarNumber}
              onChange={handleChange}
              helperText="Format: 4 digit space 4 digit space 4 digit (e.g. 9684 1552 2557)"
            />

            <TextField
              required
              fullWidth
              label="PAN Number"
              name="panNumber"
              value={formData.panNumber}
              onChange={handleChange}
            />

            <TextField
              required
              fullWidth
              label="Educational Qualification"
              name="educationalQualification"
              value={formData.educationalQualification}
              onChange={handleChange}
            />

            <Typography variant="h6" gutterBottom>
              Details of person with B Pharm or D Pharm degree
            </Typography>

            <TextField
              required
              fullWidth
              label="Name of the person"
              name="managerName"
              value={formData.managerName}
              onChange={handleChange}
            />

            <FormControl fullWidth required>
              <InputLabel>B Pharm or D Pharm or M Pharm degree</InputLabel>
              <Select
                name="degree"
                value={formData.degree}
                onChange={handleChange}
                label="B Pharm or D Pharm or M Pharm degree"
              >
                <MenuItem value="B Pharm">B Pharm</MenuItem>
                <MenuItem value="D Pharm">D Pharm</MenuItem>
                <MenuItem value="M Pharm">M Pharm</MenuItem>
              </Select>
            </FormControl>

            <TextField
              required
              fullWidth
              label="Registration number"
              name="registrationNumber"
              value={formData.registrationNumber}
              onChange={handleChange}
            />

            <TextField
              required
              fullWidth
              label="Proposed location of the store with complete address"
              name="storeLocation"
              multiline
              rows={3}
              value={formData.storeLocation}
              onChange={handleChange}
            />

            <TextField
              required
              fullWidth
              label="Tehsil"
              name="tehsil"
              value={formData.tehsil}
              onChange={handleChange}
            />

            <TextField
              required
              fullWidth
              label="City"
              name="city"
              value={formData.city}
              onChange={handleChange}
            />

            <TextField
              required
              fullWidth
              label="District"
              name="district"
              value={formData.district}
              onChange={handleChange}
            />

            <FormControl fullWidth required>
              <InputLabel>State</InputLabel>
              <Select
                name="state"
                value={formData.state}
                onChange={handleChange}
                label="State"
              >
                <MenuItem value="">--Select State--</MenuItem>
                <MenuItem value="Gujarat">Gujarat</MenuItem>
                {/* Add other states as needed */}
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel>Whether location is owned or rented</FormLabel>
              <RadioGroup
                row
                name="locationOwnership"
                value={formData.locationOwnership}
                onChange={handleChange}
              >
                <FormControlLabel value="Owned" control={<Radio />} label="Owned" />
                <FormControlLabel value="Rented" control={<Radio />} label="Rented" />
              </RadioGroup>
            </FormControl>

            <TextField
              required
              fullWidth
              label="Why do you think this location is appropriate to start a NYCS PMBJP Store"
              name="locationJustification"
              multiline
              rows={3}
              value={formData.locationJustification}
              onChange={handleChange}
            />

            <TextField
              fullWidth
              label="NYCS Share holder number (If Available)"
              name="nycsShareNumber"
              value={formData.nycsShareNumber}
              onChange={handleChange}
            />

            <TextField
              fullWidth
              label="Share holding amount (if you are an NYCS Share holder)"
              name="shareHoldingAmount"
              value={formData.shareHoldingAmount}
              onChange={handleChange}
            />
            <Box
              sx={{
                display: "flex",

                justifyContent: "center", // Centers horizontally
                alignItems: "center", // Centers vertically
                height: "100%",
              }}
            >
              <Button
                type="submit"
                variant="contained"
                size="large"
                sx={{
                  bgcolor: '#003733',
                  textAlign: "center",
                  width: "250px",
                  minWidth: "150px",
                  fontSize: "20px",
                  '&:hover': {
                    bgcolor: '#004d48'
                  }
                }}
              >
                Submit
              </Button>

            </Box>

          </Box>
        </TabPanel>
      </Box>
    </Container>
  )
}

export default JanAushadhiForm
